(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-about-hero"]) return;
  try {
    
  if (!customElements.get('ea-about-film')) {
    customElements.define('ea-about-film', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        const show = (paused) => {
          button.setAttribute('aria-pressed', paused ? 'true' : 'false');
          button.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
          button.classList.toggle('is-paused', paused);
        };
        button.addEventListener('click', () => {
          if (video.paused) { video.play(); show(false); } else { video.pause(); show(true); }
        });
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { show(true); return; }
        const start = video.play();
        if (start && start.catch) start.catch(() => show(true));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-pairs-with"]) return;
  try {
    
  // A card with data-ea-start-variant opens on that variant: its swatch is clicked once, which shows the variant's
  // photo, price and links (snippets/ea-card-swatch-row).
  const eaStartVariants = () => {
    for (const item of document.querySelectorAll('[data-ea-start-variant]')) {
      const name = item.dataset.eaStartVariant;
      const pick = [...item.querySelectorAll('.ea-swatch-row__pick')].find((el) => el.getAttribute('title') === name);
      if (pick && !pick.classList.contains('ea-swatch-row__link--current')) pick.click();
    }
  };
  // after the whole page has loaded: the swatch script and Horizon's card must be ready, or the click does nothing
  if (document.readyState === 'complete') eaStartVariants();
  else window.addEventListener('load', eaStartVariants);

  // Tabs above the product cards: a click or the arrow keys show that tab's panel and hide the others.
  const eaSelectTab = (tab) => {
    const list = tab.closest('.ea-tabs');
    for (const other of list.querySelectorAll('.ea-tabs__tab')) {
      const on = other === tab;
      other.setAttribute('aria-selected', String(on));
      other.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    }
    eaPlaceRowArrows();
  };

  // The row arrows sit at the middle of the card photos (the photo height follows the card width).
  const eaPlaceRowArrows = () => {
    for (const row of document.querySelectorAll('.ea-pairs-with--tiles slideshow-component.resource-list__carousel')) {
      const arrows = row.querySelector(':scope > slideshow-container > slideshow-arrows');
      const photo = row.querySelector('.card-gallery, .ea-soon-card__frame');
      // no arrows when every card already fits (Horizon draws them anyway; Anu, 30 Oct 2026: 3 coming-soon tiles)
      const slides = row.querySelector(':scope > slideshow-container > slideshow-slides');
      if (arrows && slides && slides.clientWidth) arrows.hidden = slides.scrollWidth <= slides.clientWidth + 2;
      if (!arrows || !photo || !photo.offsetHeight) continue;
      arrows.style.paddingBlockStart = '0px';
      const top = photo.getBoundingClientRect().top - arrows.getBoundingClientRect().top + photo.offsetHeight / 2 - 22;
      arrows.style.paddingBlockStart = `${Math.max(0, Math.round(top))}px`;
    }
  };

  // Horizon marks the slides out of view aria-hidden; their links and buttons leave the Tab order then.
  const eaSyncHiddenSlides = () => {
    for (const slides of document.querySelectorAll('.ea-pairs-with--tiles slideshow-component.resource-list__carousel > slideshow-container > slideshow-slides')) {
      if (slides.dataset.eaSync) continue;
      slides.dataset.eaSync = '1';
      const sync = (slide) => {
        if (!(slide instanceof Element) || !slide.matches('slideshow-slide')) return;
        const hidden = slide.getAttribute('aria-hidden') === 'true';
        for (const el of slide.querySelectorAll('a, button, input, [tabindex]')) {
          if (hidden) {
            if (!el.hasAttribute('data-ea-tab')) el.setAttribute('data-ea-tab', el.getAttribute('tabindex') ?? '');
            el.tabIndex = -1;
          } else if (el.hasAttribute('data-ea-tab')) {
            const old = el.getAttribute('data-ea-tab');
            if (old === '') el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', old);
            el.removeAttribute('data-ea-tab');
          }
        }
      };
      for (const slide of slides.children) sync(slide);
      new MutationObserver((records) => records.forEach((record) => sync(record.target))).observe(slides, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true,
      });
    }
  };

  const eaRowsReady = () => {
    eaPlaceRowArrows();
    eaSyncHiddenSlides();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', eaRowsReady);
  else eaRowsReady();
  window.addEventListener('load', eaPlaceRowArrows);
  window.addEventListener('resize', eaPlaceRowArrows);

  document.addEventListener('click', (event) => {
    const tab = event.target instanceof Element ? event.target.closest('.ea-tabs__tab') : null;
    if (tab) eaSelectTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target instanceof Element ? event.target.closest('.ea-tabs__tab') : null;
    if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
    const tabs = [...tab.closest('.ea-tabs').querySelectorAll('.ea-tabs__tab')];
    const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    event.preventDefault();
    next.focus();
    eaSelectTab(next);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
